var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './PreviewElements.module.scss';
var PreviewDataLegend = function (_a) {
    var actions = _a.actions;
    return (_jsx("div", __assign({ className: styles.dataLegendPreviewWrapper }, { children: actions.slice(0, 3).map(function (item) { return (_jsxs("div", { children: [_jsxs("div", __assign({ style: { background: item.color } }, { children: [_jsx("div", { children: item.name }), _jsxs("div", { children: [_jsxs("span", { children: [item.percent, "%"] }), _jsx("span", { children: item.combos })] })] })), _jsx("div", { style: { background: item.color } })] }, item.id)); }) })));
};
export default PreviewDataLegend;
